import React, { FC, lazy, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Loader from 'shared/components/Loader';
import OrderStepWrapper from 'shared/components/OrderStepWrapper';
import { shouldShowPinAndPhoneOnNoQr } from 'shared/utils/qrRedirectionRoute';

import { ROUTES } from './consts';

const PinAndPhonePage = lazy(() => import('view/PinAndPhonePage'));
const QrRedirectionPage = lazy(() => import('components/QrRedirection'));
const OTPPage = lazy(() => import('view/OTPPage'));
const LoaderPage = lazy(() => import('view/LoaderPage'));
const ScoringPage = lazy(() => import('view/ScoringPage'));
const OrderFormPage = lazy(() => import('view/OrderFormPage'));
const StepLoadingPage = lazy(() => import('view/StepLoadingPage'));
const FormalizationOptionPage = lazy(() => import('view/FormalizationOptionPage'));
const FormalizingCardPage = lazy(() => import('view/FormalizingCardPage'));
const FinalPage = lazy(() => import('view/FinalPage'));
const NotFoundPage = lazy(() => import('shared/views/NotFound'));

const NoQrRoute: FC = () => {
  const { pathname } = useLocation();

  return shouldShowPinAndPhoneOnNoQr(pathname) ? <PinAndPhonePage /> : <QrRedirectionPage />;
};

const OrderStep: FC = () => (
  <OrderStepWrapper>
    <Routes>
      <Route path={ROUTES.PIN.PATH} element={<QrRedirectionPage />} />
      <Route path={ROUTES.NO_QR.PATH} element={<NoQrRoute />} />
      <Route path={ROUTES.OTP.PATH} element={<OTPPage />} />
      <Route path={ROUTES.LOADING.PATH} element={<LoaderPage />} />
      <Route path={ROUTES.SCORING.PATH} element={<ScoringPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </OrderStepWrapper>
);

export const commonRoutes: JSX.Element = (
  <Suspense fallback={<Loader />}>
    <Routes>
      <Route path={ROUTES.MAIN.PATH} element={<OrderStep />} />
      <Route path={ROUTES.ORDER_FORM.PATH} element={<OrderFormPage />} />
      <Route path={ROUTES.STEP_LOADING.PATH} element={<StepLoadingPage />} />
      <Route path={ROUTES.FORMALIZATION_OPTION.PATH} element={<FormalizationOptionPage />} />
      <Route path={ROUTES.FORMALIZING_CARD.PATH} element={<FormalizingCardPage />} />
      <Route path={ROUTES.FINAL.PATH} element={<FinalPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Suspense>
);
